export const API_URL = process.env.REACT_APP_API_URL;

export const USER_TAG = 'User';
export const EXPENSE_TAG = 'Expenses';
export const SAVINGS_TAG = 'Savings';
